/* generated by pull.js */
const manifest = {
    "name": "Draggable Categories in Block Palette",
    "description": "Allows you to click-and-hold categories in the block palette to re-arrange them.",
    "credits": [
        {
            "name": "SharkPool",
            "link": "https://github.com/SharkPool-SP/"
        }
    ],
    "info": [
        {
            "type": "notice",
            "text": "This addon is currently somewhat buggy when enabled alongside the \"Two-column category menu\" addon.",
            "id": "draggable-incompatibility"
        }
    ],
    "userscripts": [
        {
            "url": "userscript.js"
        }
    ],
    "userstyles": [
        {
            "url": "userstyle.css"
        }
    ],
    "tags": ["editor", "new", "recommended"],
    "enabledByDefault": true,
    "dynamicEnable": true,
    "dynamicDisable": false
};
export default manifest;
